<template>
      <div>
        <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
            <div :class="'modal-dialog modal-'+size" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-weight-bold"><i v-if="titleIcon" :class="titleIcon"></i>{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" style="outline: none;" aria-label="Close" v-if="showClose">
                        <span aria-hidden="true" class="font-weight-bold" @click="onClose()">&times;</span>
                    </button>
                </div>
                <div class="modal-body" :class="classContent">
                    <slot>Modal body text goes here.</slot>
                </div>
                <div class="modal-footer" v-if="showfooter">
                    <!-- Optional extra action on the left of the footer (e.g. a
                         "Delete" button when editing an existing record). Purely
                         additive: modals that do not fill it render as before. -->
                    <slot name="footer-left"></slot>
                    <button type="button" class="btn bg-secondary text-white btn-secondary px-4" v-if="showBtnCancel" @click="onClose()">{{btnCancelText}}</button>
                    <button type="button" class="btn bg-primary text-white btn-primary px-4" v-if="showBtnAccept" :disabled="disabledAccept" @click="onAccept()">{{btnAcceptText}}</button>
                </div>
                </div>
            </div>
            </div>
        </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props : {
            title : {
                type : String,
                default : "Title Modal",
            },
            // Optional icon shown to the left of the title, given as a class
            // string (e.g. "icon-svg icon-calendar"). Purely additive: modals
            // that do not pass it render exactly as before.
            titleIcon : String,
            btnCancelText :{
                type : String,
                default : "Close"
            },
            btnAcceptText :{
                type : String,
                default : "Save"
            },
            size : {
                type : String,
                default : 'md'
            },
            showBtnAccept : {
                type : Boolean,
                default : true
            },
            // Greys out the accept button while the form has nothing to submit.
            // Purely additive: modals that do not pass it behave as before.
            disabledAccept : {
                type : Boolean,
                default : false
            },
            showBtnCancel : {
                type : Boolean,
                default : true
            },
            showfooter : {
                type : Boolean,
                default : true
            }, 
            showClose : {
                type : Boolean,
                default : false
            }, 
            classContent : String

        },
        data() {
          return {};
        },
        methods : {
            onClose(){
                this.$emit('close');
            },
            onAccept(){
                 this.$emit('accept');
            }
        }

    }
</script>
<style >
    .modal-mask {
        position: fixed;
        z-index: 500;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
    display: table-cell;
    }
    .modal-header{
        background-color: #8ebbe6;
    }
    .modal-content{
        border: none;
    }
    .modal-footer {
        padding: 0 0.75rem;
    }
    .modal-content label{
        font-size: 12px;
        margin-bottom: 5px;
        text-transform: uppercase;
    }

    @media (min-width: 576px) {
        .modal-dialog.modal-md {
            max-width: 600px;
        }
    }
</style>